import { Navigate, Route, Routes } from "react-router-dom";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { MobileBottomNav } from "./components/MobileBottomNav";
import { SkipLink } from "./components/SkipLink";
import { ArchivePage } from "./pages/ArchivePage";
import { DiscoverPage } from "./pages/DiscoverPage";
import { MethodologyPage } from "./pages/MethodologyPage";
import { ProPage } from "./pages/ProPage";
import { ReportDetailPage } from "./pages/ReportDetailPage";
import { ReportsPage } from "./pages/ReportsPage";

export default function PublicApp({ previewMode = false }: { previewMode?: boolean }) {
  return <div className="app-shell">
    {previewMode ? <div className="demo-preview-banner" role="status"><strong>DEMO / LOCAL PREVIEW</strong><span>Fixture reports only · not real FTM analysis · production data unchanged</span></div> : null}
    <SkipLink />
    <Header />
    <Routes>
      <Route path="/" element={<DiscoverPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/reports/:slug" element={<ReportDetailPage />} />
      <Route path="/archive" element={<ArchivePage />} />
      <Route path="/methodology" element={<MethodologyPage />} />
      <Route path="/pro" element={<ProPage />} />
      <Route path="/markets" element={<Navigate replace to="/reports" />} />
      <Route path="/track-record" element={<Navigate replace to="/archive" />} />
      <Route path="/market/:slug" element={<ReportDetailPage />} />
      <Route path="/pricing" element={<Navigate replace to="/pro" />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
    <MobileBottomNav />
    <Footer />
  </div>;
}
